import { Helmet } from 'react-helmet-async';

export default function PageMeta({ 
  title = 'Tenant Dispatch - Connect Property Owners with Service Professionals',
  description = 'Tenant Dispatch connects property owners and landlords with vetted maintenance professionals. Quick, reliable service for plumbing, electrical, repairs, and more.',
  keywords = 'maintenance service, property management, tenant requests, professional services',
  canonical = 'https://tenantdispatch.com',
  image = 'https://tenantdispatch.com/og-image.jpg',
  type = 'website'
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonical} />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonical} />
      
      {/* Additional SEO */}
      <meta name="language" content="English" />
      <meta name="author" content="Tenant Dispatch" />
      <meta name="robots" content="index, follow" />
      <meta httpEquiv="x-ua-compatible" content="ie=edge" />
    </Helmet>
  );
}
